import type { EventDetail } from "@cdt/shared";

import { useDeleteEvent } from "@/hooks/useEventActions";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface DeleteEventDialogProps {
  event: EventDetail;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleted?: () => void;
}

export function DeleteEventDialog({
  event,
  open,
  onOpenChange,
  onDeleted,
}: DeleteEventDialogProps) {
  const deleteMutation = useDeleteEvent();
  const hasCalendarEvent = Boolean(event.calendarEventId);

  function handleConfirm() {
    deleteMutation.mutate(
      { id: event.id },
      {
        onSuccess: () => {
          onOpenChange(false);
          onDeleted?.();
        },
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Elimina evento</DialogTitle>
          <DialogDescription>
            {hasCalendarEvent
              ? "L'evento verra' rimosso dal calendario Outlook e marcato come ignorato. La traccia email rimane nel sistema."
              : "L'evento verra' marcato come ignorato. La traccia email rimane nel sistema."}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={deleteMutation.isPending}
          >
            Annulla
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={deleteMutation.isPending}
          >
            {deleteMutation.isPending ? "Eliminazione..." : "Elimina"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
